import { useFeatureEnabled } from 'common/feature-flag/hooks/useFeatureEnabled';

export const useTaskManagementEnabled = (warehouseId?: string) => {
  const isV1Venue = useFeatureEnabled(
    'warehouse-v1-functionality',
    warehouseId ? [warehouseId] : undefined,
  );
  return !isV1Venue;
};
